// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.scrolling-page[data-v-0f73f585] {\n  margin-bottom: 1em;\n}\n@media print {\n.pdf-preview[data-v-0f73f585] {\n    display: none;\n}\n}\n", ""]);
// Exports
module.exports = exports;
